// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ChevronRightDouble = createIcon(
  <path
    clipRule="evenodd"
    d="M12.5667 9.24636C12.2153 8.89488 12.2153 8.32504 12.5667 7.97356C12.9182 7.62209 13.488 7.62209 13.8395 7.97356L17.2311 11.3652C17.5826 11.7166 17.5826 12.2865 17.2311 12.638L13.8395 16.0296C13.488 16.381 12.9182 16.381 12.5667 16.0296C12.2153 15.6781 12.2153 15.1082 12.5667 14.7568L15.3219 12.0016L12.5667 9.24636ZM6.7553 14.7569C6.40383 15.1083 6.40383 15.6782 6.7553 16.0297C7.10678 16.3811 7.67662 16.3811 8.0281 16.0297L11.4197 12.6381C11.7712 12.2866 11.7712 11.7167 11.4197 11.3653L8.0281 7.97367C7.67662 7.62219 7.10677 7.62219 6.7553 7.97367C6.40383 8.32514 6.40383 8.89499 6.7553 9.24646L9.51051 12.0017L6.7553 14.7569Z"
    fillRule="evenodd"
  />,
);
